import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
`